import { render, staticRenderFns } from "./calendarsetUp.vue?vue&type=template&id=67f80e96&scoped=true"
import script from "./calendarsetUp.vue?vue&type=script&lang=js"
export * from "./calendarsetUp.vue?vue&type=script&lang=js"
import style0 from "./calendarsetUp.vue?vue&type=style&index=0&id=67f80e96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f80e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f80e96')) {
      api.createRecord('67f80e96', component.options)
    } else {
      api.reload('67f80e96', component.options)
    }
    module.hot.accept("./calendarsetUp.vue?vue&type=template&id=67f80e96&scoped=true", function () {
      api.rerender('67f80e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/setting/calendarsetUp.vue"
export default component.exports